export const ORG_ROLES = ['clinic_admin', 'physiotherapist', 'patient'] as const;
export type OrgRole = (typeof ORG_ROLES)[number];

export const STAFF_ROLES = ['clinic_admin', 'physiotherapist'] as const satisfies readonly OrgRole[];

export const MEMBERSHIP_STATUSES = ['invited', 'active', 'suspended', 'removed'] as const;
export type MembershipStatus = (typeof MEMBERSHIP_STATUSES)[number];

export function isStaff(roles: readonly OrgRole[]): boolean {
  return roles.some((r) => (STAFF_ROLES as readonly OrgRole[]).includes(r));
}
